export default class CAJA1080RequestModel {}
